export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "कोई रिकॉर्ड नहीं है",
    "notifications.rp_has_been_updated": "रेजिडेंशियल प्रोजेक्ट को अद्यतन किया गया है",
    "moduleTitle.files": "फाइल्स",
    "label.coordinator": "समन्वयक",
    "sidebar.translations_managment": "",
    "table.file": "फ़ाइल",
    "label.report_overview": "",
    "label.parent_agreement": "प्रिंट करने योग्य माता पिता का सहमति फ़ॉर्म",
    "parentalConsent.i_consent_to_and_understand_that": "6. मैं सहमति देता हूं और समझता हूं कि अवार्ड  से संबंधित कुछ गतिविधियों में भाग लेने वाले प्रतिभागियों की तस्वीरों को लिया जा सकता है और ऐसी तस्वीरों का उपयोग प्रचार के उद्देश्यों के लिए किया जा सकता है, बशर्ते उचित रिज़र्व फॉर्म पर दोनों, प्रतिभागी और उनके माता-पिता / अभिभावक द्वारा हस्ताक्षर किए गए हैं।",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. मैं समझता हूं कि प्रतिभागियों को रिकार्ड बुक या ORB, अवार्ड ऑपरेटर द्वारा (समय-समय पर संशोधन) के व्यवहारों के मानकों और मानदंडों के संबंध में, अवार्ड यूनिट की आवश्यकताओं में निहित अवार्ड आवश्यकताओं, आपातकालीन योजना, गतिविधियों का आकलन और अवार्ड से संबंधित साहसिक यात्रा के आचरण, का पालन करना आवश्यक है। मैं यह भी समझता हूँ की यदि मैं इन सभी आवश्यकताओं को पूरा नहीं कर पता तो अवार्ड यूनिट प्रतिभागी की भागीदारी में अपनी स्वीकृति वापस ले सकती है।",
    "table.end_date": "अंतिम तिथि",
    "label.activation_date": "सक्रियण दिनांक",
    "label.report": "",
    "label.award_is_offline": "अवार्ड ऑफलाइन है",
    "label.pending_changes": "लंबित परिवर्तन ...",
    "errors.min_nights_required": "न्यूनतम रातों (nights) की आवश्यकता है",
    "label.country": "देश",
    "notifications.award_leader_has_been_returned": "अवार्ड लीडर संशोधित किया गया है",
    "notifications.participant_has_been_updated": "प्रतिभागी को अपडेट किया गया है",
    "label.phone_number": "फ़ोन नंबर",
    "roles.aj_assessor": "साहसिक यात्रा निर्धारक",
    "notifications.person_state_has_been_changed": "व्यक्ति की स्तिथी को बदल दिया गया है",
    "pageTitle.dashboard": "डैशबोर्ड",
    "moduleTitle.global_payment_method": "वैश्विक भुगतान विधि",
    "label.organization_type": "संगठन का प्रकार",
    "button.account_settings": "अकाउंट सेटिंग",
    "notifications.contact_has_been_updated": "संपर्क अपडेट कर दिया गया है",
    "participant.recover_password": "पासवर्ड पुनर्प्राप्त करें",
    "notifications.assessment_request_has_been_sent": "आकलन अनुरोध भेजा गया है",
    "button.unassign": "",
    "label.start_date": "आरंभ करने की तिथि",
    "label.assign_labels": "",
    "sidebar.participants": "प्रतिभागी",
    "roles.coordinator": "समन्वयक",
    "label.organization_contact": "संगठन संपर्क",
    "tabs.customization": "अनुकूलन",
    "sidebar.award_units": "अवार्ड यूनिट ",
    "button.change_goal": "लक्ष्य बदलें",
    "translationsManagement.selectProject": "translationsManagement.selectProject",
    "award.rp": "रेजिडेंशियल प्रोजेक्ट",
    "label.size": "आकार",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "गतिविधि को मंजूरी दे दी गई है",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "मूल्यांकन अनुरोध पुनः भेजें",
    "notifications.template_has_been_removed": "टेम्पलेट हटा दिया गया है",
    "button.award_settings": "अवार्ड सेटिंग्स",
    "pageTitle.payment": "भुगतान",
    "tasks.return_award": "अवार्ड को संशोधित करें",
    "label.link": "लिंक",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "मेरा क्षेत्र कार्यालय - संबंधित संपर्क",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "अनुभाग साइन-ऑफ",
    "table.logs": "लॉग्स",
    "moduleTitle.remove_file": "फाइल हटायें?",
    "label.email_confirmed": "ईमेल की पुष्टि की",
    "notifications.activity_has_been_returned": "गतिविधि को संशोधित किया गया है",
    "label.note": "नोट",
    "button.show": "",
    "tabs.adventurous_journey": "साहसिक यात्रा",
    "sidebar.my_todolist": "",
    "label.here": "यहाँ",
    "organisation.change_award_mode": "अवॉर्ड्स का मोड बदलें",
    "table.note_from_al": "अवार्ड लीडर का नोट",
    "label.gender": "लिंग",
    "moduleTitle.remove": "हटाना?",
    "errors.must_be_less_than": "{Limit} से कम होना चाहिए",
    "button.logout": "लोग आउट",
    "label.no_selected_participants": "कोई चयनित प्रतिभागी नहीं",
    "button.new_aj_event": "नई साहसिक यात्रा घटना",
    "label.employement_status": "रोज़गार की स्थिति",
    "tabs.logs": "लॉग्स",
    "tabs.contacts": "संपर्क",
    "label.option": "विकल्प",
    "dashboard.charts": "चार्ट",
    "notifications.rp_has_been_approved": "रेजिडेंशियल प्रोजेक्ट को मंजूरी दे दी गई है",
    "pageTitle.new_participant": "नया प्रतिभागी",
    "notifications.award_leader_has_been_approved": "अवार्ड लीडर को मंजूरी दे दी गई है",
    "moduleTitle.would_you_like_to_remove_leader_training": "क्या आप अवार्ड लीडर्स के प्रशिक्षण को हटाना चाहते हैं?",
    "moduleTitle.update_configuration_value": "कॉन्फ़िगरेशन अपडेट करें",
    "table.description": "विवरण",
    "table.organization": "संगठन",
    "label.youtube": "यूट्यूब",
    "label.author": "रचयिता",
    "table.suitable_for_award_level": "अवार्ड स्तर के लिए उपयुक्त",
    "label.content_update": "कृपया प्रतीक्षा करें। सामग्री अपडेट कर रहा है ...",
    "notifications.new_question_has_been_added": "नया प्रश्न जोड़ा गया है",
    "pageTitle.nao_awards": "नेशनल ऑफिस - अवार्ड्स",
    "table.last_name": "अंतिम नाम ",
    "moduleTitle.adventurous_journey_detail": "यात्रा विवरण",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "प्रोजेक्ट स्थान प्रकार",
    "label.email_help_award_level": "",
    "label.date": "तारीख",
    "label.previous_completed_award_place": "कहाँ",
    "button.show_more": "अधिक दिखाएं",
    "label.wwc_number": "WWC संख्या",
    "button.filter": "फ़िल्टर",
    "notifications.rp_has_been_returned": "रेजिडेंशियल प्रोजेक्ट को संशोधित किया गया है",
    "pageTitle.residetial_project_assessor_report": "रेजिडेंशियल प्रोजेक्ट - निर्धारक रिपोर्ट",
    "label.generating": "उत्पन्न हो रहा है ...",
    "moduleTitle.finance_system_data": "वित्त प्रणाली डेटा",
    "notifications.adventurous_journey_state_has_been_changed": "साहसिक यात्रा की स्थिति बदल दी गयी है",
    "route.levels": "स्तर",
    "moduleTitle.activity_leader": "गतिविधि लीडर",
    "tasks.approve_event": "घटना को स्वीकृति दें",
    "tasks.reject_event": "घटना को संशोधित करें",
    "table.region": "क्षेत्र",
    "pageTitle.nao_award_leaders": "नेशनल ऑफिस - अवार्ड लीडर्स",
    "errors.must_be_at_least": "कम से कम {min} वर्ण होने चाहिए",
    "table.title": "शीर्षक",
    "table.last_activity": "अंतिम गतिविधि",
    "tasks.delete_registration": "पंजीकरण हटाएं",
    "table.date_time": "दिनांक / समय",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. अवार्ड  ऑपरेटर आपकी गोपनीयता का सम्मान करने के लिए प्रतिबद्ध हैं। अवार्ड  में भाग लेने के उद्देश्य के लिए व्यक्तिगत जानकारी इस फॉर्म पर एकत्र की जाती है। जो प्रतिभागी  हमें यह जानकारी नहीं देते हैं वे अवार्ड  में भाग नहीं ले सकते (ध्यान दें कि यह प्रतिभागियों के डेटा के गैर-प्रावधान पर लागू नहीं होता है) हम आपकी व्यक्तिगत जानकारी का उपयोग अन्य अवार्ड  गतिविधियों या घटनाओं के बारे में आपको जानकारी भेजने के लिए भी कर सकते हैं, हमारा मानना है कि इसमें आपकी रुचि हो सकती है, हम इस जानकारी को अन्य स्थानीय या अंतरराष्ट्रीय संगठनों और सेवा प्रदाताओं को बता सकते हैं जो हमें अवार्ड  के संचालन और प्रशासन में सहायता करते हैं।  यदि आप हमसे संपर्क करना चाहते हैं या अपनी व्यक्तिगत जानकारी प्राप्त करने के लिए कृपया अवार्ड ऑपरेटर को लिखें। आप अपनी गोपनीयता नीति की एक प्रति का अनुरोध करने के लिए अवार्ड ऑपरेटर से भी संपर्क कर सकते हैं",
    "aj.practice_journey": "अभ्यास यात्रा",
    "notification.log_has_been_restored": "गतिविधि लॉग को पुनर्स्थापित किया गया है",
    "tabs.my_participants": "मेरे प्रतिभागी",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "पर्यवेक्षक",
    "moduleTitle.your_parental_consent": "आपके माता-पिता की सहमति",
    "route.registration_participants": "पंजीकरण प्रतिभागी",
    "placeholder.start_typing": "टाइप करना शुरू करें...",
    "tasks.approve_award": "अवार्ड को स्वीकार करें",
    "route.registrations": "पंजीकरण",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "साहसिक यात्रा घटना बना दी गई",
    "states.supervisor_approval": "निर्धारक अनुमोदन",
    "label.description": "विवरण",
    "button.leave_anyway": "छोड़ें",
    "tabs.registrations": "पंजीकरण",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "notifications.translations_has_been_updated.button",
    "pageTitle.nao_registration": "नेशनल ऑफिस - पंजीकरण",
    "pageTitle.mro_logs": "मेरा क्षेत्र कार्यालय - लॉग्स",
    "meta.page_not_found": "पृष्ठ नहीं मिला।",
    "label.bulk_action_unsuccessful": "",
    "global.days": "दिन",
    "table.review": "समीक्षा",
    "table.as_assessor_for": "के लिए निर्धारक के रूप में",
    "roles.if_staff_statistical_user": "आई ऍफ़ सांख्यिकी उपयोगकर्ता",
    "table.levels": "स्तर",
    "label.suitable_for_level": "स्तर के लिए उपयुक्त",
    "pageTitle.leaders": "लीडर्स",
    "moduleTitle.send_test_email": "टेस्ट ईमेल भेजें",
    "pageTitle.tasks_removed_registration": "हटाए गए प्रतिभागी का पंजीकरण",
    "label.you_will_be_forced_to_login_again_after_change": "परिवर्तन के बाद आपको फिर से प्रवेश करने के लिए कहा जाएगा",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "अनुभाग साइन-ऑफ",
    "pageTitle.payments": "भुगतान",
    "global.nights": "रात",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "संगठन चुनें",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "फाइल अपलोड करो",
    "label.migrated_contact_email": "माइग्रेटेड संपर्क ईमेल",
    "label.for_award_unit": "अवार्ड यूनिट के लिए",
    "label.aj_template_note": "टेम्पलेट नोट",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "कृपया प्रतिभागियों में सुधार / प्रदर्शन / प्रतिबद्धता पर टिप्पणी करें",
    "label.consent_already_given_login": "सहमति पहले ही दी गई थी। कृपया अपने बच्चे के रूप में लॉगिन करें",
    "participant.level_start_date": "{value} आरंभ करने की तिथि",
    "sidebar.my_region_office": "मेरा क्षेत्रीय कार्यालय",
    "states.section_signoff": "अनुभाग साइन-ऑफ",
    "moduleTitle.assessor_details": "मूल्यांकनकर्ता का विवरण",
    "moduleTitle.adventurous_journey_settings": "साहसिक यात्रा सेटिंग",
    "moduleTitle.note_from_al": "अवार्ड लीडर का नोट",
    "button.add_role": "भूमिका जोड़ें",
    "table.run": "चलाएं",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "यूजर एप्प गाइड - अवार्ड लीडर",
    "tabs.section_approval": "अनुभाग स्वीकृति",
    "roles.award_verifier": "अवार्ड सत्यापनकर्ता",
    "tabs.activity_approval": "गतिविधि अनुमोदन",
    "logs.add_log": "लॉग जोड़ें",
    "tabs.award": "अवार्ड",
    "notifications.this_role_has_read_only_persmission": "इस भूमिका में केवल पढ़ने की अनुमति है",
    "table.no_filtered_results": "फ़िल्टर नहीं किए गए परिणाम",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "स्थान का विवरण",
    "label.optional": "(वैकल्पिक)",
    "errors.do_not_match": "मेल नहीं खाता",
    "label.use_comma_for_multiple_entries": "एकाधिक प्रविष्टियों के लिए अल्पविराम का प्रयोग करें",
    "label.operating_authority": "ऑपरेटिंग प्राधिकरण",
    "label.activity_section": "गतिविधि अनुभाग",
    "notifications.you_have_been_logged_out": "आप लॉग आउट हो चुके हों",
    "table.finished": "समाप्त हो गया",
    "button.same_as_billing": "बिलिंग के समान",
    "table.payment": "भुगतान",
    "table.current_level": "मौजूदा स्तर",
    "button.view_nao": "",
    "table.email_confirmation": "ईमेल की पुष्टि",
    "moduleTitle.shipping_address": "शिपिंग पता",
    "label.secondary_phone_type": "वैकल्पिक फ़ोन का प्रकार",
    "notifications.saved": "सहेजें",
    "pageTitle.all_participants": "सभी प्रतिभागी",
    "label.first_name": "प्रथम नाम",
    "label.oa_price": "OA मूल्य",
    "table.award_mode": "अवार्ड मोड",
    "tabs.api_keys": "",
    "award.award_detail": "अवार्ड का विवरण",
    "tabs.user_management": "उपयोगकर्ता प्रबंधन",
    "tabs.all_events": "सभी घटनाक्रम",
    "notifications.history_record_has_been_removed": "इतिहास रिकॉर्ड हटाया गया है",
    "award.no_data": "कोई डेटा नहीं",
    "notifications.preparation_training_has_been_added": "तैयारी और प्रशिक्षण जोड़ा गया है",
    "label.message": "सन्देश",
    "notifications.participant_info_updated": "प्रतिभागी की जानकारी अपडेट कर दी गई है",
    "roles.nao_staff": "NAO स्टाफ",
    "tabs.adventurous_journeys": "साहसिक यात्राएँ",
    "label.gops": "",
    "route.upload": "अपलोड",
    "notifications.history_record_has_been_added": "इतिहास रिकॉर्ड जोड़ा गया है",
    "notifications.history_record_has_been_updated": "इतिहास रिकॉर्ड अपडेट किया गया है",
    "label.no_data": "कोई डेटा नहीं",
    "button.add_coordinator": "समन्वयक जोड़ें",
    "label.you_are_already_logged_as": "आप पहले से ही लॉग इन हैं",
    "route.my_national_office": "मेरा नेशनल ऑफिस",
    "tabs.leaders": "लीडर्स",
    "label.email_confirmation": "ईमेल की पुष्टि",
    "table.registration_date": "पंजीकरण तिथि",
    "notifications.role_has_been_removed": "भूमिका हटा दी गई है",
    "button.move": "स्थानांतरित",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "विवरण",
    "table.award_unit": "अवार्ड यूनिट",
    "sidebar.settings": "सेटिंग्स",
    "dashboard.leader_state": "लीडर्स - राज्य के अनुसार",
    "notifications.award_unit_has_been_approved": "अवार्ड यूनिट को मंजूरी दे दी गई है",
    "states.awaiting_approval": "मंजूरी का इंतजार",
    "table.level": "स्तर",
    "table.action_requested": "",
    "label.organisation_mode": "आर्गेनाईजेशन मोड",
    "label.no_note": "कोई नोट नहीं",
    "tabs.my_events": "मेरी घटनाएं",
    "notifications.participants_have_been_added": "प्रतिभागियों को जोड़ा गया है",
    "tabs.registration_questions": "",
    "button.delete_registration": "पंजीकरण हटाएं",
    "notifications.parental_consent_link_has_been_sent": "अभिभावकीय सहमति लिंक भेजा गया है",
    "moduleTitle.select_role_organization": "भूमिका और संगठन का चयन करें",
    "label.experience": "अनुभव",
    "translationsManagement.modal.title": "translationsManagement.modal.title",
    "table.ic": "स्वतंत्र देश",
    "table.id": "आई डी",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "क्या आप इस खाते को हटाना चाहते हैं?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "वेब यूजर गाइड - अवार्ड लीडर",
    "label.journey_type": "यात्रा का प्रकार",
    "button.setup": "सेट अप",
    "tabs.my_national_office": "मेरा नेशनल ऑफिस",
    "notifications.training_has_been_removed": "प्रशिक्षण हटा दिया गया है",
    "label.nominated_and_identified_persons": "नामांकित और पहचान किए गए व्यक्ति जो सभी डेटा देख सकते हैं लेकिन संपादित नहीं कर सकते हैं",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "निष्क्रियता के कारण आपको लॉग आउट कर दिया गया है",
    "states.award_leader_signoff": "अवार्ड लीडर साइन-ऑफ",
    "table.award_signoff_attempts": "अवार्ड साइन-ऑफ प्रयास",
    "sidebar.regions": "क्षेत्र",
    "label.activity_deleted_note": "यह गतिविधि हटा दी गई है आप नीचे दिए गए बटन पर क्लिक करके इसे पुनर्स्थापित कर सकते हैं।",
    "table.total": "कुल",
    "errors.a_problem_has_occured_during_processing": "प्रसंस्करण के दौरान एक समस्या हुई है, अधिक जानकारी देखें",
    "participant.participant_already_has_gold_award": "प्रतिभागी के पास पहले से ही एक गोल्ड पुरस्कार है",
    "pageTitle.mro": "मेरा क्षेत्रीय कार्यालय",
    "notifications.authorization_code_has_expired": "प्राधिकरण कोड की समय सीमा समाप्त हो गई है",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "साहसिक यात्रा घटनाक्रम",
    "global.loading": "लोड हो रहा है",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "पंजीकरण",
    "label.any_string": "कोई स्ट्रिंग",
    "contact.change_contact_status": "संपर्क की स्थिति बदलें",
    "tabs.registration": "पंजीकरण",
    "label.override_payment_note": "भुगतान नोट ओवरराइड करें",
    "notifications.section_has_been_signed_off": "अनुभाग बंद कर दिया गया है",
    "label.payment_date": "भुगतान दिनांक",
    "button.approve": "स्वीकृत",
    "moduleTitle.loggin_in": "लॉग इन हो रहा है",
    "label.website": "वेबसाइट",
    "label.role": "भूमिका",
    "table.assessor_report": "निर्धारक रिपोर्ट",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "पहले मूल्यांकनकर्ता के रूप में काम किया था",
    "pageTitle.registrations": "पंजीकरण",
    "parentalConsent.this_form_must_be_completed": "<Strong> 18 वर्ष की आयु / उस देश में कानूनी उत्तरदायित्व की राष्ट्रीय उम्र जिसके तहत आप रहते हैं </strong> के तहत माता-पिता / अभिभावक द्वारा यह फ़ॉर्म <strong> आवश्यक रूप </strong> से भरा जाना चहिये ",
    "button.apply": "",
    "errors.include_at_least_one_number": "कम से कम एक संख्या का चरित्र शामिल करें",
    "label.content_restore": "सत्र ताज़ा किया जा रहा ...",
    "logs.hour": "घंटे",
    "parentalConsent.i_have_read_and_understand": "7. मैंने अवार्ड के रूपरेखा के रूप में निर्धारित विभिन्न स्तरों और आवश्यकताओं को पढ़ा और समझ लिया है (इस फॉर्म का पृष्ठ 5)।",
    "notifications.award_was_deleted": "",
    "label.journey_category": "यात्रा श्रेणी",
    "notifications.search_cancelled": "खोज को बाधित किया गया था, आपको खोज समाप्त होने के लिए इंतजार करना होगा।",
    "route.detail": "विवरण",
    "route.user_guide": "यूजर गाइड",
    "moduleTitle.history": "इतिहास",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "वो प्रतिभागी जो किसी अवार्ड लीडर के साथ संलंग नहीं",
    "states.inactive": "निष्क्रिय",
    "pageTitle.search_results": "खोज परिणाम",
    "button.proceed_to_login": "लॉगिन करने के लिए आगे बढ़ें",
    "pageTitle.assessor_report_reject": "निर्धारक रिपोर्ट संशोधित ",
    "notifications.contact_has_been_removed": "संपर्क हटा दिया गया है",
    "sidebar.operating_authorities": "ऑपरेटिंग प्राधिकरण",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "तैयारी और प्रशिक्षण",
    "route.user_guide_web_leader": "वेब यूजर गाइड - अवार्ड लीडर",
    "label.position_in_organization": "संगठन में स्थिति",
    "errors.emails_dont_match": "ईमेल एक - दूसरे से मेल नहीं खाते",
    "route.my_participants": "मेरे प्रतिभागी",
    "pageTitle.customisations": "अनुकूलन",
    "tabs.localization_files": "स्थानीयकरण फ़ाइलें",
    "table.assessor_approval": "निर्धारक अनुमोदन",
    "tabs.related_contacts": "संबंधित संपर्क",
    "table.aus": "अवार्ड यूनिट ",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "संभावित मान:",
    "label.if_your_download_doesnt_start": "यदि आपका डाउनलोड स्वचालित रूप से प्रारंभ नहीं होता है तो यह क्लिक करें",
    "route.independent_award_centres": "स्वतंत्र पुरस्कार केंद्र",
    "pageTitle.user_guide": "उपयोगकर्ता मार्गदर्शक",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "मेरा संगठन - विवरण",
    "pageTitle.nao_detail": "नेशनल ऑफिस - विवरण",
    "button.change": "परिवर्तन",
    "award.aj": "साहसिक यात्रा",
    "table.award_state": "अवार्ड की स्तिथि ",
    "pageTitle.tasks_award_signoff": "अवार्ड साइन-ऑफ",
    "pageTitle.regions": "क्षेत्र",
    "notifications.award_has_been_signed_off": "अवार्ड को साइन-ऑफ़ किया गया है",
    "dashboard.award_approved_by": "अवार्ड  स्वीकृत - 2016 में स्तर के अनुसार",
    "tabs.new_template": "नया टेम्पलेट",
    "error.parent_email_must_be_filled": "अभिभावक ईमेल भरना होगा",
    "label.organisation_invoicing_name": "संगठन का इनवॉइस का नाम",
    "pageTitle.related_contacts": "संबंधित संपर्क",
    "button.try_again": "चेतावनी बंद करें और फिर से प्रयास करें",
    "label.cannot_be_change_to_another": "किसी अन्य अवार्ड स्तर पर बदला नहीं जा सकता",
    "notifications.lead_coordinator_has_been_set": "नया लीड समन्वयक सेट किया गया है",
    "label.training_name": "प्रशिक्षण का नाम",
    "moduleTitle.new_contact": "नया संपर्क",
    "translationsManagement.modal.updateTitle": "translationsManagement.modal.updateTitle",
    "moduleTitle.offline_award_units_signoff": "ऑफ़लाइन अवार्ड  लीडर साइनऑफ",
    "notifications.award_level_has_been_changed": "अवार्ड स्तर बदल दिया गया है",
    "label.subject": "विषय",
    "route.silver_level": "रजत स्तर",
    "label.privacy_notice": "",
    "label.switch_organization": "संगठन बदलें",
    "meta.dofe_name": "द ड्यूक ऑफ एडिनबर्ग पुरस्कार",
    "route.profile": "प्रोफाइल",
    "roles.super_user": "सुपर उपयोगकर्ता",
    "dashboard.while_you_were_gone": "जब आप नहीं थे",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "मध्य नाम",
    "moduleTitle.new_activity": "नई गतिविधि",
    "organisation.would_you_like_to_remove": "क्या आप इस संगठन को निकालना चाहते हैं?",
    "label.state_province": "राज्य / प्रांत / क्षेत्र",
    "moduleTitle.your_home_address": "आपके घर का पता",
    "tabs.sign_offs": "साइन-ऑफ ",
    "moduleTitle.logs": "लॉग्स",
    "button.view_more": "अधिक देखें",
    "label.profile": "प्रोफाइल",
    "label.title": "शीर्षक",
    "tabs.award_signoff": "अवार्ड साइन-ऑफ",
    "label.post_code": "पोस्ट कोड",
    "states.ceremony_certificate": "समारोह",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. मैं अवार्ड यूनिट और अवार्ड ऑपरेटर को प्रदान की गई किसी भी व्यक्तिगत जानकारी के प्रावधान (सहभागिता डेटा सहित) के लिए सहमति देता हूं। मैं इस जानकारी को प्रासंगिक पुरस्कार ऑपरेटर की गोपनीयता नीति के प्रावधानों के अनुसार इलाज (समय-समय पर संशोधित), राष्ट्रीय गोपनीयता सिद्धांत या अधिनियम डेटा प्रोटेक्शन एक्ट (यूके) 1998 (या किसी भी स्थानीय रूप से समतुल्य पॉलिसी में निहित ), और गोपनीयता कानून के तहत किसी भी अन्य गोपनीयता कानून, मानदंड, दिशानिर्देश या उन पर बाध्यकारी निर्देशके लिए सहमति देता हूं।",
    "label.user_guide_web_participant": "उपयोगकर्ता वेब गाइड - प्रतिभागी",
    "label.award_unit_type": "अवार्ड यूनिट का प्रकार",
    "states.complete": "",
    "table.participant_state": "प्रतिभागी की स्तिथि",
    "pageTitle.my_organization_payment": "मेरा संगठन - भुगतान",
    "table.approved": "अनुमोदित",
    "pageTitle.my_organization_contacts": "मेरा संगठन - संपर्क",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "<Strong> {state} </strong> में बदलें",
    "label.integer": "पूर्णांक",
    "notifications.translationUpdateInterrupted": "notifications.translationUpdateInterrupted",
    "notifications.password_has_been_changed": "पासवर्ड बदला जा चुका है",
    "button.invite_assessor": "मूल्यांकनकर्ता को आमंत्रित करें",
    "label.other_activity": "अन्य गतिविधि",
    "notifications.parental_consent_has_been_sent": "माता-पिता की सहमति भेजी गई है",
    "button.revise": "संशोधन",
    "errors.end_date_must_be_after_start_date": "समाप्ति तिथि प्रारंभ तिथि के बाद होनी चाहिए",
    "label.award_leader_signoff_date": "अवार्ड लीडर साइन-ऑफ तिथि",
    "parentalConsent.i_understand_every_participant_must": "8. मैं समझता हूं कि प्रत्येक प्रतिभागी को एक अवार्ड यूनिट के माध्यम से अवार्ड  में भाग लेना चाहिए, जिसको कि प्रतिभागियों को और अवार्ड की प्रस्तावित गतिविधियों को स्वीकार या अस्वीकार करने का विवेकाधिकार है ।",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "साहसिक यात्रा",
    "global.day": "दिन",
    "moduleTitle.coordinator": "समन्वयक",
    "label.region": "क्षेत्र",
    "button.add_history_record": "इतिहास रिकॉर्ड जोड़ें",
    "moduleTitle.adventurous_journey_template_settings": "साहसिक यात्रा टेम्पलेट सेटिंग्स",
    "notifications.personal_details_have_been_updated": "व्यक्तिगत विवरण अपडेट किए गए हैं",
    "sidebar.ics": "स्वतंत्र देश (जीबीटी)",
    "table.independent_award_centre": "इंडिपेंडेंट अवार्ड सेंटर",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "ईमेल",
    "label.backoffice": "label.backoffice",
    "moduleTitle.parent_consent": "माता-पिता / अभिभावक सहमति",
    "label.photo_consent_given": "प्रतिभागी इससे सहमत हैं कि हम प्रोन्नति के लिए उसकी प्रोफ़ाइल तस्वीर का उपयोग कर सकते हैं",
    "moduleTitle.authorising_contact": "संपर्क प्राधिकृत करना",
    "label.assessment_with_role": "{role} मूल्यांकन",
    "dashboard.type_of_awards": "अवार्ड यूनिट का प्रकार",
    "moduleTitle.payment": "भुगतान",
    "states.in_progress": "प्रगति में",
    "logs.no_logs": "कोई लॉग्स नहीं",
    "sidebar.my_office": "मेरा कार्यालय",
    "label.assessor_report": "निर्धारक रिपोर्ट",
    "notifications.rp_has_been_signed_off": "रेजिडेंशियल प्रोजेक्ट को बंद कर दिया गया है",
    "tabs.labels": "",
    "sidebar.payments": "भुगतान",
    "meta.profile_questions": "प्रोफाइल - प्रश्न",
    "label.fax": "फैक्स",
    "label.email_help_custom_link": "",
    "label.last_name": "अंतिम नाम",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "प्रतिभागियों - स्तर के अनुसार",
    "tabs.award_leaders": "अवार्ड लीडर्स",
    "label.i_confirm_that_ive_witnessed": "मैं पुष्टि करता हूं कि मैंने प्रतिभागियों को नीचे दी गई गतिविधियों के लिए लॉग बुक देखा है",
    "table.lead_coordinator": "",
    "states.deleted": "हटाया गया",
    "label.no_answers": "कोई जवाब नहीं",
    "button.add": "जोड़ें",
    "label.exchequer_number": "राजकोष सं०",
    "label.waiting": "प्रतीक्षा",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "पंजीकरण को संशोधित करें",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "माता-पिता अनुमोदन",
    "table.assessor_approve": "निर्धारक अनुमोदन",
    "errors.some_fields_requires_your_attention": "कुछ फ़ील्ड के लिए आपका ध्यान आवश्यक है",
    "aj.qualifying_journey": "योग्यता यात्रा",
    "route.awards": "अवार्ड्स",
    "table.registration": "पंजीकरण",
    "pageTitle.assessors": "मूल्यांकनकर्ता",
    "notifications.award_has_been_updated": "अवार्ड को अद्यतन किया गया है",
    "errors.must_be_one_of": "इनमें से एक होना चाहिए: {enums}",
    "pageTitle.logs": "लॉग्स",
    "notifications.notifications.invitation_has_been_sent": "निमंत्रण भेजा गया है",
    "route.national_offices": "नेशनल ऑफिस",
    "notifications.training_has_been_updated": "प्रशिक्षण को अद्यतन किया गया है",
    "label.parent_last_name": "माता-पिता / संरक्षक का अंतिम नाम",
    "table.leaders": "लीडर्स",
    "states.award_level_complete": "अवार्ड स्तर पूर्ण",
    "button.reset": "रीसेट",
    "sidebar.my_award_unit": "मेरी अवार्ड यूनिट",
    "pageTitle.all_aj_events": "सभी साहसिक यात्रा घटनाएं",
    "label.activity": "गतिविधि",
    "moduleTitle.are_you_sure": "क्या आप निश्चित हैं?",
    "route.gold_level": "स्वर्ण स्तर",
    "table.evidence": "साक्ष्य",
    "label.delivery_confirmed": "डिलिवरी की पुष्टि",
    "parentalConsent.as_the_parent": "माता-पिता / अभिभावक के रूप में, मैं प्रचार उद्देश्यों के लिए फाउंडेशन द्वारा उपयोग की जाने वाली किसी भी छवियों के लिए सहमति देता हूं",
    "label.awardMode.offline": "ऑफलाइन",
    "tasks.approve_registration": "पंजीकरण स्वीकृत करें",
    "note.change_the_email_will_change": "नोट: ईमेल बदलने से माइग्रेटेड संपर्क ईमेल भी बदल जाएगा",
    "notifications.participant_has_been_approved": "प्रतिभागी को मंजूरी दे दी गई है",
    "label.reached_activity_limit": "क्रियाकलापों की सीमा इस गतिविधि अनुभाग में अधिकतम तक पहुंच गई है। प्रतिभागियों में प्रत्येक अनुभाग में अधिकतम 3 गतिविधियां हो सकती हैं।",
    "label.facebook": "फेसबुक",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "तैयारी एवं प्रशिक्षण हटा दिया गया है",
    "pageTitle.settings": "सेटिंग्स",
    "participant.level_registration_date": "{value} पंजीकरण तिथि",
    "notifications.question_has_been_removed": "प्रश्न हटा दिया गया है",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "लीडर्स",
    "notifications.participants_have_been_transferred": "प्रतिभागियों को स्थानांतरित कर दिया गया है",
    "tabs.assessors": "मूल्यांकनकर्ता",
    "sidebar.dashboard": "डैशबोर्ड",
    "pageTitle.independent_award_centers": "स्वतंत्र अवार्ड केंद्र",
    "label.search": "खोजें",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "प्रतिभागी से नोट",
    "errors.required_field": "आवश्यक फ़ील्ड",
    "tasks.approve_task": "कार्य स्वीकृत करें",
    "logs.edit_log": "लॉग संपादित करें",
    "table.state": "राज्य",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "बंद करे",
    "label.parent_first_name": "माता-पिता / अभिभावक का पहला नाम",
    "parentalConsent.i_understand_that_the_participant": "1. मैं समझता हूं कि जब तक इस फॉर्म को (माता-पिता / अभिभावक सहमति सहित) पूरा करके प्रासंगिक अवार्ड ऑपरेटर को, लागू पंजीकरण शुल्क तथा अवार्ड यूनिट की स्वीकृति  के साथ नहीं लौटता, तब तक प्रतिभागी अवार्ड मैं भाग नहीं ले सकता ।",
    "tabs.award_units": "अवार्ड यूनिट ",
    "table.hours": "घंटे",
    "label.type": "प्रकार",
    "notifications.adventurous_journey_has_been_removed": "साहसिक यात्रा को हटा दिया गया है",
    "label.aj_is_not_approved_yet": "साहसिक यात्रा अभी तक अनुमोदित नहीं है",
    "roles.authorizing_contact": "संपर्क प्राधिकृत करना",
    "table.date_submitted_to_office_signoff": "अवार्ड ऑफिस  साइन-ऑफ को प्रस्तुत करने की तिथि",
    "notifications.section_has_been_returned": "अनुभाग को संशोधित किया गया है",
    "table.created_by": "द्वारा बनाया गया",
    "route.user_guide_web_participant": "उपयोगकर्ता वेब गाइड - प्रतिभागी",
    "route.templates": "टेम्पलेट्स",
    "states.awaiting_sign_off": "अवार्ड लीडर साइन-ऑफ",
    "table.phone": "फ़ोन",
    "label.parental_consent": "माता पिता की सहमति",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "कांस्य स्तर",
    "label.invoice_currency": "इनवॉइस की मुद्रा",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "इस समय सर्वर उपलब्ध नहीं है। बाद में पुन: प्रयास करें। अगर समस्या बनी रहती है, तो कृपया हमारी सहायता टीम से संपर्क करें।",
    "notifications.contact_has_been_created": "संपर्क बना दिया गया है",
    "pageTitle.profile_questions": "प्रोफाइल - प्रश्न",
    "table.observation_files": "निरीक्षण फाइलें",
    "table.participants": "प्रतिभागी",
    "tasks.no_evidence": "कोई प्रमाण उपलब्ध नहीं है",
    "button.edit": "संपादित करें",
    "moduleTitle.leader": "लीडर",
    "notifications.new_template_has_been_updated": "नया टेम्पलेट अपडेट कर दिया गया है",
    "table.name": "नाम",
    "label.no_results": "कोई परिणाम नहीं",
    "moduleTitle.documents": "दस्तावेज़",
    "button.invite": "आमंत्रण",
    "label.goal": "लक्ष्य",
    "pageTitle.nao_award_units": "नेशनल ऑफिस - अवार्ड यूनिट्स",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "कम से कम {length} वर्ण लंबा",
    "label.email_help_note": "",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "भूमिका हटायें?",
    "label.total": "कुल",
    "label.delete_participant_award_info": "",
    "route.leaders": "लीडर्स",
    "table.start_date": "आरंभ करने की तिथि",
    "moduleTitle.coordinators": "समन्वयक",
    "button.create": "बनाएं",
    "tabs.awards": "अवार्ड्स",
    "parentalConsent.form_has_been_sent": "माता-पिता की सहमति भेजी गई है",
    "states.journey_approval": "यात्रा अनुमोदन",
    "pageTitle.reports": "रिपोर्ट",
    "table.journey_type": "यात्रा का प्रकार",
    "label.yes": "हां",
    "pageTitle.assessor_report": "निर्धारक रिपोर्ट",
    "label.organization": "संगठन",
    "notifications.award_leader_has_been_updated": "अवार्ड लीडर को अद्यतन किया गया है",
    "moduleTitle.edit_role": "भूमिका संपादित करें",
    "table.journey_activity": "यात्रा गतिविधि",
    "label.location": "स्थान",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "साहसिक यात्राएं",
    "global.assessor": "मूल्यांकनकर्ता",
    "moduleTitle.profile_questions": "प्रोफाइल - प्रश्न",
    "activity.cannot_edit_activity_if_award_in_state": "अगर अवार्ड {state} स्तिथि में है, तो गतिविधि को संपादित नहीं किया जा सकता है",
    "moduleTitle.assessor_detail": "निर्धारक विवरण",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. मैं समझता हूं कि अवार्ड यूनिट द्वारा अवार्ड  में स्वीकार करने पर, प्रतिभागी को एक रिकॉर्ड बुक प्राप्त होगी या ऑनलाइन रिकॉर्ड बुक (ORB) तक पहुंच प्राप्त होगी।  पुरस्कार के संबंध में गतिविधियों को शुरू करने से पहले प्रतिभागी रिकॉर्ड बुक या ORB में निहित पुरस्कार की आवश्यकताओं को पढ़ेंगे। मैं समझता हूं कि अवार्ड  यूनिट को यह निर्धारित करने के लिए विवेक है कि क्या अवार्ड की आवश्यकताओं को पूरा किया गया है और इसलिए एक ब्रोंज, सिल्वर या गोल्ड  पुरस्कार जारी किया जाना चाहिए।  मैं समझता हूं कि अवार्ड ऑपरेटर, व्यक्तिगत दुर्घटना और सार्वजनिक देनदारी बीमा के संबंध में सीमित बीमा के साथ प्रतिभागियों को अवार्ड यूनिट द्वारा स्वीकृति  प्रदान कर सकता है, लेकिन  व्यक्तिगत दुर्घटना कवर को प्राप्त करने और बनाए रखने की ज़िम्मेदारी प्रतिभागी / और उनके मातापिता या अभिभावक की होगी।",
    "notifications.award_has_been_returned": "अवार्ड संशोधित किया गया है",
    "label.code_of_conduct": "",
    "button.new_contact": "नया संपर्क",
    "tabs.payments": "भुगतान",
    "roles.naa_oa_staff": "NAA OA स्टाफ",
    "label.switch_organisation_hint": "आप ऊपरी-दाएं कोने मेनू में 'स्विच संगठन' चुनकर कभी भी इस संवाद को खोल सकते हैं",
    "label.expiration_date": "समाप्ति की तिथि",
    "tabs.participants": "प्रतिभागी",
    "table.practice": "अभ्यास",
    "notifications.one_activity_has_to_remain": "अनुभाग में एक गतिविधि को रहना होगा।",
    "label.qualifications": "योग्यता",
    "states.organization_approval": "अवार्ड ऑफिस साइन-ऑफ",
    "errors.must_be_an_integer": "पूर्णांक होना चाहिए",
    "participant.send_confirmation_email_again_question": "पुष्टि ईमेल फिर से भेजें?",
    "button.dismiss": "खारिज",
    "table.advice": "",
    "label.years_of_working_experience": "कार्य अनुभव के वर्ष",
    "notifications.search_failed": "खोज करते समय एक त्रुटि हुई बाद में पुन: प्रयास करें।",
    "notifications.changes_have_been_saved": "परिवर्तनों को सुरक्षित किया गया है",
    "moduleTitle.resend_parental_consent_link": "माता-पिता की सहमति लिंक फिर से करें?",
    "label.activity_type": "गतिविधि का प्रकार",
    "label.change_award": "अवार्ड का स्तर बदलें",
    "label.email": "ईमेल",
    "button.remove": "हटायें",
    "button.download": "डाउनलोड",
    "label.vat_treatment": "वैट ट्रीटमेंट",
    "pageTitle.aj_template_new": "नई साहसिक यात्रा टेम्पलेट",
    "table.per_page": "प्रति पृष्ठ",
    "notifications.translations_has_been_updated": "notifications.translations_has_been_updated",
    "notification.award_mode_has_been_updated": "अवार्ड का मोड अपडेट कर दिया गया है",
    "tasks.revise_item": "आइटम को संशोधित करें",
    "button.resend_parental_consent": "माता-पिता की सहमति फिर से भेजें",
    "table.weeks_completed_required": "सप्ताह पूरे / आवश्यक ",
    "label.last_modified": "अंतिम बार संशोधित",
    "table.major": "प्रमुख",
    "label.vat_number": "वैट संख्या",
    "errors.passwords_dont_match": "पासवर्ड मेल नहीं खाते",
    "table.country": "देश",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "प्रश्न अपडेट कर दिया गया है",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "प्राधिकरण कोड अब वैध नहीं है",
    "errors.must_be_no_more_than": "{max} वर्णों से अधिक नहीं होना चाहिए",
    "notifications.event_has_been_rejected": "घटना को संशोधित किया गया है",
    "tabs.customizations": "अनुकूलन",
    "label.name_organization": "नाम",
    "button.add_log": "लॉग जोड़ें",
    "moduleTitle.invite_assessor": "मूल्यांकनकर्ता को आमंत्रित करें",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "सभी प्रतिभागियों को एक नए अवार्ड लीडर को स्थानांतरित कर दिया जाएगा",
    "label.repeat_email": "ईमेल दोहराएं",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "भूमिका को अद्यतन किया गया है",
    "roles.if_staff_stat_user": "यदि सांख्यिकीय उपयोगकर्ता",
    "participant.delete_account": "खाता हटा दो",
    "moduleTitle.would_you_like_to_remove_this_log": "क्या आप इस लॉग को हटाना चाहते हैं?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "यात्रा श्रेणी",
    "sidebar.manual_data_import": "मैनुअल डेटा आयात",
    "label.created_after_date": "के बाद बनाया गया",
    "route.my_organization": "मेरा संगठन",
    "button.show_list": "",
    "label.leaders": "लीडर्स",
    "notifications.log_has_been_modified": "लॉग को संशोधित किया गया है",
    "button.upload_file": "दस्तावेज अपलोड करें",
    "moduleTitle.which_section_do_you_want_to": "आप किस अनुभाग में 'प्रगति में' लौटना चाहते हैं?",
    "tabs.bronze_level": "कांस्य स्तर",
    "notifications.participants_have_been_saved": "प्रतिभागियों को सहेज लिया गया है",
    "pageTitle.aj_template_detail": "साहसिक यात्रा",
    "label.parent_email": "माता-पिता / अभिभावक का ईमेल",
    "map.appr_location": "अनुमानित पता:",
    "notifications.log_has_been_removed": "लॉग निकाल दिया गया है",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "रुके रहें",
    "table.previous_level": "पिछला स्तर",
    "label.award_start_date": "अवार्ड प्रारंभ तिथि",
    "assessor_report.returned_to_participant": "प्रतिभागी को वापस आ गया",
    "pageTitle.tasks_assessors_registration": "मूल्यांकनकर्ता पंजीकरण",
    "aj.cannot_modify_award": "यदि प्रतिभागियों को साहसिक यात्रा के लिए सौंप दिया गया है तो अवार्ड स्तर को संशोधित नहीं किया जा सकता है ",
    "moduleTitle.lost_internet_connection": "ऐसा लगता है कि आपने इंटरनेट कनेक्शन खो दिया है",
    "states.ceremony": "समारोह",
    "participant.reactivate_account": "खाते को पुनः सक्रिय करें",
    "label.birthdate": "जन्म की तारीख",
    "pageTitle.assessment_send_successfully": "आकलन सफलतापूर्वक भेजा गया",
    "states.assessor_approval": "निर्धारक अनुमोदन",
    "award.change_award_level": "अवार्ड का स्तर बदलें",
    "label.url_no_longer_valid": "यह url अब मान्य नहीं है।",
    "button.update": "अपडेट",
    "label.secondary_email": "वैकल्पिक ईमेल",
    "button.role_edit": "संपादित करें",
    "table.award_leader": "अवार्ड लीडर",
    "label.level": "स्तर",
    "tasks.evidence": "साक्ष्य",
    "notifications.participant_is_already_in_list": "प्रतिभागी पहले से ही सूची में है",
    "button.clear": "स्पष्ट",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "सेट अप",
    "table.activity": "गतिविधि",
    "label.copy_to_clipboard": "",
    "route.award_units": "अवार्ड यूनिट ",
    "button.upload_photo": "तसवीर डालें",
    "table.hours_completed_required": "घंटे पूरे / आवश्यक ",
    "table.first_name": "प्रथम नाम ",
    "notifications.adventurous_journey_has_been_returned": "साहसिक यात्रा को संशोधित किया गया है",
    "pageTitle.national_offices": "नेशनल ऑफिस",
    "notifications.you_have_been_logged_in": "आप लॉग इन कर चुके हैं",
    "logs.offline": "",
    "moduleTitle.add_role": "भूमिका जोड़ें",
    "label.user_app_guide_participant": "उपयोगकर्ता एप्लिकेशन गाइड - प्रतिभागी",
    "notifications.file_has_been_removed": "फ़ाइल हटा दी गई है",
    "label.send_message": "",
    "button.select": "चयन करें",
    "label.reason_of_deletion": "हटाए जाने के कारण",
    "label.user_guide": "यूजर गाइड",
    "pageTitle.nao_participants": "नेशनल ऑफिस - प्रतिभागी",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "द्वारा डाली गई",
    "tasks.approve_item": "आइटम को स्वीकृति दें",
    "tasks.restore_participant_registration": "प्रतिभागी पंजीकरण पुनर्स्थापित करें?",
    "label.awardMode.hybrid": "हाइब्रिड",
    "table.first_activity_started": "पहली गतिविधि शुरू हुई",
    "moduleTitle.dates": "तिथियां",
    "table.no_results": "कोई परिणाम नहीं",
    "states.registration_approval": "पंजीकरण स्वीकृति",
    "table.breakdown_of_hours": "बाधित रहें का समय",
    "pageTitle.tasks_registration": "प्रतिभागी पंजीकरण",
    "button.create_new": "नया बनाएं",
    "sidebar.todolist": "कार्य सूची",
    "label.active_participants": "सक्रिय प्रतिभागी",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "संशोधन कार्य",
    "organisation.change_organisation_state": "संगठन की स्थिति बदलें",
    "moduleTitle.roles": "भूमिकाएँ",
    "label.no_config_key_available": "इस सेक्शन के लिए कोई कॉन्फ़िगरेशन के उपलब्ध नहीं है",
    "placeholder.selectLanguage": "placeholder.selectLanguage",
    "states.office_signoff": "अवार्ड ऑफिस साइन-ऑफ",
    "notifications.translations_has_been_updated.failure": "notifications.translations_has_been_updated.failure",
    "logs.minute": "मिनट",
    "label.last_activity": "अंतिम गतिविधि",
    "sidebar.user_guide": "यूजर गाइड्स",
    "label.trained_award_leader": "एक प्रशिक्षित अवार्ड लीडर",
    "table.progress": "प्रगति",
    "table.suboperating_authorities": "उप-संचालन प्राधिकरण",
    "activity.cannot_edit_activity_offline": "यह प्रतिभागी ऑफलाइन मोड में काम कर रहा है। <br> <br>\nअगर पुरस्कार सेमी-ऑफ़लाइन मोड में हो तो आप गतिविधियाँ,  साहसिक यात्रा या रेजिडेंशियल प्रोजेक्ट  संपादित नहीं कर सकते",
    "label.user_does_not_have_permissions": "प्रयोक्ता <strong> {user} </strong> को इस सामग्री को देखने के लिए अनुमति नहीं है",
    "notifications.assessor_has_been_approved": "मूल्यांकनकर्ता को मंजूरी दे दी गई है",
    "route.activity_approval": "गतिविधि अनुमोदन",
    "moduleTitle.role": "भूमिका",
    "button.run": "चलाएं",
    "label.to": "सेवा में",
    "notifications.file_has_been_updated": "फाइल को अपडेट किया गया है",
    "moduleTitle.edit_coordinator": "समन्वयक संपादित करें",
    "notifications.authorization_code_is_no_longer_valid": "प्राधिकरण कोड अब वैध नहीं है",
    "button.reject": "संशोधन",
    "label.label.participant_status": "प्रतिभागी की स्थिति",
    "award.gold_level": "स्वर्ण स्तर",
    "sidebar.variables": "चर",
    "parentalConsent.checkbox_copy": "मैं पुष्टि करता हूं कि मैं {firstName} {lastName} के माता-पिता / संरक्षक हूं।  मैं एक प्रशिक्षित अवार्ड लीडर के पर्यवेक्षण के तहत {organisationName} में अवार्ड में भाग लेने के लिए उसकी मेरी सहमति देता हूं।  मैंने उपरोक्त वर्णित, और पुरस्कार ऑपरेटर की वेबसाइट पर, अवार्ड में भागीदारी की आवश्यकताओं और शर्तों को पढ़, समझ लिया है और सहमत हूं।",
    "button.go_to_dashboard": "डैशबोर्ड पर जाएं",
    "button.add_option": "विकल्प जोड़ें",
    "label.is_completed": "पूरा कर लिया है",
    "pageTitle.award_units": "अवार्ड यूनिट",
    "states.completed": "पूरा कर लिया है",
    "button.adventurous_journey_template_settings": "साहसिक यात्रा टेम्पलेट सेटिंग्स",
    "label.system_rights": "सिस्टम राइट्स",
    "label.assessor_assesstment_award_start_date": "label.assessor_assesstment_award_start_date",
    "label.update_translation_question": "",
    "button.login": "लॉग इन करें",
    "label.name_of_the_unit": "यूनिट का नाम",
    "button.send": "भेजें",
    "award.ajs": "साहसिक यात्राएँ",
    "meta.payments_expired": "समाप्त हो चुके भुगतान",
    "label.age": "आयु",
    "notifications.payment_info_updated": "भुगतान जानकारी अपडेट कर दी गई है",
    "table.is_completed": "पूरा कर लिया है",
    "table.invited_by": "द्वारा आमंत्रित",
    "route.files": "फ़ाइलें",
    "route.assessors": "मूल्यांकनकर्ता",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "मेरे प्रतिभागी",
    "label.change_leader_status": "नेता की स्थिति बदलें",
    "moduleTitle.parent_consent_form": "माता-पिता / अभिभावक सहमति फॉर्म",
    "notifications.authorization_contact_has_been_set": "प्राधिकरण संपर्क सेट किया गया है",
    "button.close": "बंद करे",
    "label.independent_country": "स्वतंत्र देश",
    "notifications.aj_preparation_training_has_been_returned": "साहसिक यात्रा तैयारी और प्रशिक्षण को  संशोधित किया गया है",
    "route.history_log": "पुराने लॉग",
    "participant.account_settings": "अकाउंट सेटिंग",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "फ़ाइल यूआरएल निर्दिष्ट कॉन्फ़िगरेशन में  नहीं है",
    "notifications.award_unit_has_been_removed": "अवार्ड यूनिट / आईएसी को हटा दिया गया है",
    "table.parent": "माता-पिता",
    "label.mode_of_transport": "परिवहन के साधन",
    "label.parental_consent_email_info": "प्रमुख ईमेल की जांच करना न भूलें और अवार्ड डिटेल स्क्रीन से मैन्युअल रूप से सहमति भेजें।",
    "label.current_award": "वर्तमान अवार्ड",
    "table.action": "कार्य",
    "pageTitle.suboperating_authorities": "उप-ऑपरेटिंग अथॉरिटी",
    "notifications.award_leader_has_been_assigned": "अवार्ड लीडर एसाइन्ड किया गया है",
    "tabs.sign_offs_locally": "स्थानीय रूप से साइन-ऑफ करें",
    "Activity log has been restored": "गतिविधि लॉग को पुनर्स्थापित किया गया है",
    "sidebar.naos": "NAO",
    "tabs.aj_templates": "साहसिक यात्रा टेम्पलेट्स",
    "notifications.logging_out": "लॉग आउट हो रहा ...",
    "label.update_label": "",
    "button.organisation_settings": "संगठन सेटिंग्स",
    "tabs.independent_award_centers": "स्वतंत्र अवार्ड केंद्र",
    "label.current": "",
    "table.location": "स्थान",
    "button.search": "खोजें",
    "notifications.aj_preparation_training_has_been_approved": "साहसिक यात्रा तैयारी और प्रशिक्षण को मंजूरी दे दी गई है",
    "route.participants": "प्रतिभागी",
    "label.other_location_information": "अन्य स्थान जानकारी",
    "label.number_of_records": "रिकॉर्ड की संख्या",
    "translationsManagement.infoLabel": "translationsManagement.infoLabel",
    "parentalConsent.i_consent_to_pay_all": "5. मैं प्रतिभागी की अवार्ड से संबंधित किसी भी गतिविधि या कार्य में भाग लेने के दौरान किसी भी दुर्घटना, चोट, बीमारी या  यात्रा करने के दौरान  किसी भी दुर्घटना के परिणामस्वरूप, सभी डॉक्टर, नर्सों या अस्पताल आवास शुल्क और प्रतिभागी की ओर से किए गए खर्चों का भुगतान करने की सहमति देता हूं।",
    "label.nationality": "राष्ट्रीयता",
    "states.approval": "अनुमोदन",
    "notifications.something_went_wrong": "कुछ गलत हो गया",
    "aj.practice": "अभ्यास",
    "label.addressLine2": "पता दूसरी पंक्ति",
    "label.please_leave_a_note": "कृपया एक नोट छोड़ें",
    "placeholder.select": "चयन करें",
    "label.observations": "टिप्पणियां",
    "label.aim": "लक्ष्य",
    "label.addressLine1": "पता पहली पंक्ति",
    "roles.aj_instructor": "साहसिक यात्रा प्रशिक्षक",
    "meta.payments_waiting": "भुगतान - प्रतीक्षारत",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "प्रशिक्षक",
    "moduleTitle.remove_customization_and_reset": "अनुकूलन हटाएं और कॉन्फ़िग मान रीसेट करें?",
    "notifications.participant_registration_has_been_restored": "प्रतिभागी पंजीकरण बहाल कर दिया गया है",
    "organisation.change_award_unit_mode": "आर्गेनाईजेशन का मोड बदलें",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "प्रतिभागी को हटा दिया गया है",
    "label.language_settings": "भाषा सेटिंग",
    "notifications.event_has_been_approved": "घटना अनुमोदित किया गया है",
    "label.password": "पासवर्ड",
    "label.text": "टेक्स्ट",
    "table.observations": "टिप्पणियां",
    "notifications.participant_has_been_created": "प्रतिभागी बना दिया गया है",
    "table.note_for_al": "अवार्ड लीडर के लिए नोट",
    "label.payment_confirmed": "भुगतान की पुष्टि हो गई है",
    "label.previous_completed_award_level": "पिछला स्तर (ORB नहीं)",
    "pageTitle.new_aj_event": "नई साहसिक यात्रा घटना",
    "label.backend": "label.backend",
    "label.relationship_to_participant": "प्रतिभागी से संबंध",
    "award.physical_recreation": "फिजिकल रिक्रिएशन",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "निर्धारक रिपोर्ट अस्वीकार",
    "label.supervisor_report": "पर्यवेक्षक रिपोर्ट",
    "table.role": "भूमिका",
    "route.user_guide_web_nao": "उपयोगकर्ता वेब गाइड - NAO",
    "label.page_not_found": "404 पृष्ठ नहीं मिला।",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "फाइल अपलोड हो गई है",
    "moduleTitle.address": "पता",
    "moduleTitle.lead_coordinator": "प्रमुख समन्वयक",
    "pageTitle.login": "लॉग इन करें",
    "label.frontoffice": "label.frontoffice",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "रेजिडेंशियल प्रोजेक्ट की स्थापना की गई है",
    "moduleTitle.award_unit": "अवार्ड यूनिट",
    "button.remove_file": "फ़ाइल को हटाएं",
    "moduleTitle.billing_address": "बिल भेजने का पता",
    "pageTitle.my_aj_events": "मेरे साहसिक यात्रा की घटनाएं",
    "route.tasks": "कार्य",
    "button.confirm": "बंद करे",
    "label.national_award_authority": "नेशनल अवार्ड अथॉरिटी",
    "label.independent_award_centre": "स्वतंत्र अवार्ड केंद्र",
    "award.generate_award_report": "रिपोर्ट बनायें",
    "route.my_region_office_customization": "मेरा क्षेत्रीय कार्यालय- अनुकूलन",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "पासवर्ड परिवर्तन अनुरोध भेजा गया है",
    "tabs.detail": "विवरण",
    "participant.change_participant_status": "प्रतिभागी की स्थिति बदलें",
    "table.key": "",
    "label.find_address": "पता खोजें",
    "notifications.assessor_has_been_rejected": "मूल्यांकनकर्ता को संशोधित किया गया है",
    "label.transfer_participants": "प्रतिभागियों को स्थानांतरित करें",
    "button.continue_to_payment_gateway": "भुगतान गेटवे के लिए जारी रखें",
    "notifications.participant_registration_has_been_removed": "प्रतिभागी पंजीकरण हटा दिया गया है",
    "moduleTitle.page_not_found": "404 पृष्ठ नहीं मिला",
    "route.adventurous_journeys": "साहसिक यात्राएँ",
    "states.registration_assessment": "पंजीकरण आकलन",
    "heading.change_award_unit_mode": "अवार्ड यूनिट का मोड बदलें",
    "label.user_guide_web_nao": "उपयोगकर्ता वेब गाइड - NAO",
    "tabs.silver_level": "रजत स्तर",
    "table.paid_by": "द्वारा भुगतान",
    "label.your_report_has_been_successfully_sent": "आपकी रिपोर्ट सफलतापूर्वक भेजा गया है",
    "sidebar.my_organization": "मेरा संगठन",
    "pageTitle.participants": "प्रतिभागी",
    "notifications.preparation_training_has_been_updated": "तैयारी एवं प्रशिक्षण को अद्यतन किया गया है",
    "moduleTitle.server_is_unreachable": "सर्वर पहुंच से बाहर है",
    "label.last_activity_date": "",
    "award.bronze_level": "कांस्य स्तर",
    "moduleTitle.award_units": "अवार्ड यूनिट्स",
    "table.completed": "पूरा कर लिया है",
    "moduleTitle.revise_message": "संदेश संशोधित करें",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "कांस्य से स्वर्ण स्तर तक",
    "button.change_password": "पासवर्ड बदलें",
    "label.nao_price": "NAO मूल्य",
    "label.payment_state": "भुगतान की स्तिथि",
    "label.wwc_expired": "WWC की अवधि समाप्त हो गई",
    "label.award_office_signoff_date": "अवार्ड कार्यालय साइन-ऑफ तिथि",
    "label.award_unit": "अवार्ड यूनिट",
    "award.gold_level_short": "स्वर्ण",
    "moduleTitle.other_info": "अन्य सूचना",
    "table.note": "टिप्पणी",
    "label.search_by_email_first_or_last": "ईमेल, प्रथम या अंतिम नाम से खोजें",
    "tabs.history": "इतिहास",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "अनसाइनड प्रतिभागी",
    "table.main_award_leader": "समन्वयक",
    "parentalConsent.i_as_the_parent": "3. मैं समझता हूं कि कुछ गतिविधियों को उच्च जोखिम माना जाता है और उच्च जोखिम वाली गतिविधियों को पुरस्कार ऑपरेटर की बीमा व्यवस्थाओं में शामिल नहीं किया जा सकता है।   मैं समझता हूं कि पुरस्कार में प्रतिभागियों की भागीदारी से उत्पन्न होने वाले सभी जोखिमों की ज़िम्मेदारी केवल प्रतिभागी पर ही होती है",
    "label.state": "राज्य",
    "notifications.award_leader_has_been_removed": "अवार्ड लीडर हटा दिया गया है",
    "tabs.organization_detail": "संगठन का विवरण",
    "table.operating_authorities": "ऑपरेटिंग प्राधिकरण",
    "label.available_labels": "",
    "modal.select": "चयन करें",
    "tabs.expired_payments": "समाप्त हो चुके भुगतान",
    "moduleTitle.note_for_al": "अवार्ड लीडर के लिए नोट",
    "moduleTitle.confirm": "पुष्टि करें",
    "notification.new_activity_added": "नई गतिविधि जोड़ दी गई है",
    "notifications.award_leader_has_been_moved": "अवार्ड लीडर स्थानांतरित कर दिया गया है",
    "label.award_mode": "अवार्ड मोड",
    "label.phone": "फ़ोन",
    "notifications.organization_has_been_updated": "संगठन को अद्यतन किया गया है",
    "moduleTitle.assessor": "आंकलनकर्ता",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "माता-पिता अनुमोदन",
    "label.date_of_delivery": "डिलीवरी की तारीख",
    "sidebar.assessors": "मूल्यांकनकर्ता",
    "label.journey_activity": "यात्रा गतिविधि",
    "award.inactive_award": "निष्क्रिय अवार्ड",
    "label.end_date": "अंतिम तिथि",
    "label.orb_testing": "",
    "label.no_activities": "कोई गतिविधि नहीं",
    "moduleTitle.please_confirm": "कृपया पुष्टि करें",
    "button.login_with_another_account": "अलग खाते के साथ लॉगिन करें",
    "tasks.reject_registration": "पंजीकरण को संशोधित करें",
    "label.submitted_after_date": "इसके बाद प्रस्तुत",
    "label.update_translations_successful": "",
    "button.assign_leader": "लीडर असाइन करें",
    "table.already_running": "पहले से ही चल रहा है",
    "label.no": "नहीं",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "वैकल्पिक फ़ोन नंबर",
    "label.my_experience": "मेरा अनुभव",
    "notifications.adventurous_journey_has_been_approved": "साहसिक यात्रा को मंजूरी दे दी गई है",
    "pageTitle.mro_detail": "मेरा क्षेत्रीय कार्यालय - विवरण",
    "moduleTitle.nao_specific_info": "NAO से सम्बंधित जानकारी",
    "label.preparing_document_for_import": "आयात के लिए दस्तावेज़ तैयार करना",
    "tasks.observations": "टिप्पणियां",
    "notifications.confirmation_email_has_been_sent": "पुष्टिकरण ईमेल भेजा गया है",
    "button.restore": "पुनर्स्थापित",
    "label.importing_file": "फ़ाइल आयात करना",
    "label.or_dont_agree": "या सहमत नहीं है? आप ऐसा कर सकते हैं",
    "moduleTitle.award_leader": "अवार्ड लीडर",
    "label.me": "(मुझे)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "तालिका निर्यात करें",
    "organisation.move_award_unit": "अवार्ड यूनिट को हटायें",
    "label.file_category": "",
    "notifications.connecting_to_server": "सर्वर से सम्बद्ध कर रहा है...",
    "parentalConsent.i_understand_that_a_and_b": "11. मैं समझता हूं कि: <br /> a एक प्रतिभागी को मोटर वाहन चलाने या अन्य प्रतिभागियों को इस अवार्ड  से संबंधित गतिविधियों में भाग लेने के लिए परिवहन नहीं करना चाहिए जब तक कि प्रतिभागी एक उपयुक्त और वैध ड्राइविंग लाइसेंस नहीं रखता है और प्रतिभागी के ड्राइविंग के परिणामस्वरूप घायल व्यक्ति को कवर करने के लिए उचित तृतीय पक्ष बीमा नहीं है; और <br /> b एक प्रतिभागी को किसी भी व्यक्ति द्वारा संचालित नहीं किया जाना चाहिए जो अवार्ड में भाग लेने के प्रयोजनों के लिए आवर्ड के आयोजन में शामिल नहीं है या उसमें सहायता नहीं करता है जब तक कि कोई व्यक्ति उचित और वैध ड्राइविंग लाइसेंस नहीं रखता है और व्यक्तिगत ड्राइविंग के परिणामस्वरूप घायल व्यक्ति को कवर करने के लिए उपयुक्त तृतीय पक्ष बीमा ना हो ",
    "table.reason": "",
    "pageTitle.contacts": "संपर्क",
    "states.award_leader_approval": "अवार्ड लीडर साइन-ऑफ",
    "meta.payments": "भुगतान",
    "label.suboperating_authority": "उप-संचालन प्राधिकरण",
    "route.my_region_office": "मेरा क्षेत्रीय कार्यालय",
    "states.registration_not_approved": "पंजीकरण स्वीकृत नहीं है",
    "label.direct_entrant": "प्रत्यक्ष प्रवेशी",
    "tabs.all_participants": "सभी प्रतिभागी",
    "tabs.payment": "भुगतान",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "नया पासवर्ड दोहराएँ",
    "label.other_roles": "",
    "logs.hours": "घंटे",
    "notifications.spreadsheet_has_been_imported_successfully": "स्प्रेडशीट को सफलतापूर्वक आयात किया गया है",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "व्यक्तिगत विवरण",
    "label.bulk_action_emailing": "",
    "route.my_events": "मेरी घटनाएं",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "निम्न और ऊपरी केस दोनों वर्ण शामिल करें",
    "tabs.removed_participant_registrations": "हटाए गए प्रतिभागी का पंजीकरण",
    "sidebar.mynao": "मेरा NAO",
    "tabs.office_details": "कार्यालय विवरण",
    "label.major": "प्रमुख",
    "tabs.documents": "दस्तावेज़",
    "label.new_password": "नया पासवर्ड",
    "sidebar.adventure_journey": "साहसिक यात्रा",
    "pageTitle.customizations": "अनुकूलन",
    "moduleTitle.assessor_report": "{role} रिपोर्ट",
    "label.registration_date": "पंजीकरण तिथि",
    "notifications.training_has_been_added": "प्रशिक्षण जोड़ा गया है",
    "aj.qualifying": "योग्यता",
    "moduleTitle.you_have_been_logged_out_session_terminated": "आपको लॉग आउट कर दिया गया है क्योंकि सत्र पहले से समाप्त हो चुका है",
    "award.service": "सर्विस",
    "notifications.rp_state_has_been_changed": "रेजिडेंशियल प्रोजेक्ट की स्तिथि बदल दी गई है",
    "label.ctest_access": "",
    "table.created": "बना दिया गया है",
    "tasks.revise_task": "संशोधन कार्य",
    "button.assign": "नियत करें",
    "button.return": "संशोधन",
    "table.status": "स्थिति",
    "button.restore_activity": "गतिविधि को पुनर्स्थापित करें",
    "tabs.new_aj_event": "नई साहसिक यात्रा घटना",
    "roles.if_staff_viewer": "आई ऍफ़ स्टाफ व्यूअर",
    "notifications.new_template_has_been_created": "नया टेम्प्लेट बनाया गया है",
    "global.something_went_wrong": "कुछ गलत हो गया है",
    "table.expire_day": "समाप्ति का दिन",
    "tabs.history_log": "पुराने लॉग",
    "label.form_of_payment": "भुगतान का तरीका",
    "button.add_training": "प्रशिक्षण जोड़ें",
    "label.par_reg_cust_note": "यह टैब आपको प्रतिभागियों को अनुकूलित करने की अनुमति देता है जो प्रतिभागी पंजीकरण में प्रदर्शित होते हैं और आपके द्वारा एकत्रित किए जा रहे डेटा को प्रभावित करते हैं। यदि आप परिवर्तन करने की इच्छा रखते हैं तो कृपया अपने क्षेत्रीय कार्यालय से संपर्क करें - केवल IAF प्रणाली  व्यवस्थापक के पास इन परिवर्तनों को करने के लिए पहुँच है।",
    "label.my_qualification": "मेरी योग्यता",
    "button.add_new_profile_question": "नया प्रोफाइल प्रश्न जोड़ें",
    "table.operating_authority": "संचालन प्राधिकरण ",
    "table.aim": "लक्ष्य",
    "table.awards": "अवार्ड्स",
    "participant.deactivate_account": "खाता निष्क्रिय करें",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "दिनांक",
    "tasks.would_you_like_to_delete": "क्या आप इस प्रतिभागी को हटाना चाहते हैं?",
    "notifications.configuration_value_has_been_updated": "कॉन्फ़िगरेशन मान अद्यतन किया गया है",
    "ajTemplates.fill_from_template": "टेम्पलेट्स से भरें",
    "contact.send_test_email": "टेस्ट ईमेल भेजें",
    "moduleTitle.aj_preparation_and_training": "साहसिक यात्रा तैयारी और प्रशिक्षण",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "माता-पिता / अभिभावक का फ़ोन नंबर",
    "label.nao_regulations": "",
    "award.skills": "स्किल",
    "label.reject_application": "इस एप्लिकेशन को अस्वीकार करें।",
    "leader.delete_account": "खाता हटायें",
    "table.assign": "सौंपना",
    "roles.aj_supervisor": "साहसिक यात्रा पर्यवेक्षक",
    "label.logout": "लोग आउट",
    "moduleTitle.award_leader_edit": "अवार्ड लीडर को संपादित करें",
    "moduleTitle.training": "प्रशिक्षण",
    "notifications.coordinator_has_been_removed": "समन्वयक हटा दिया गया है",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "समन्वयक",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "तैयारी",
    "table.delete": "हटाना",
    "label.safeguarding_policy": "",
    "sidebar.reports": "रिपोर्ट",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "ऑपरेटिंग अथॉरिटी",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "पुष्टि",
    "notifications.invitation_has_been_sent": "निमंत्रण भेजा गया है",
    "pageTitle.independent_countries": "स्वतंत्र देश",
    "label.assessors_email": "मूल्यांकनकर्ता का ईमेल",
    "tasks.approve_assessor_registration": "मूल्यांकनकर्ता पंजीकरण को स्वीकृति दें",
    "table.award_duration": "अवार्ड अवधि",
    "notifications.organization_has_been_moved": "संगठन स्थानांतरित कर दिया गया है",
    "pageTitle.nao_payment": "नेशनल ऑफिस - भुगतान",
    "participant.history_log": "पुराने लॉग",
    "label.rejected_with_note": "",
    "label.already_running": "पहले से ही चल रहा है",
    "button.continue": "button.continue",
    "award.no_data_to_show": "दिखाने के लिए कोई डेटा नहीं है",
    "participant.send_email_invitation_again_question": "ईमेल आमंत्रण फिर से भेजें?",
    "label.reason_for_changing_assessor": "निर्धारक को बदलने का कारण",
    "button.delete": "हटायें",
    "moduleTitle.requirements_and_conditions": "आवश्यकताएं और शर्तें",
    "roles.leader": "लीडर",
    "label.if_download_doesnt": "अगर डाउनलोड स्वचालित रूप से प्रारंभ नहीं होता है, तो कृपया अपने ब्राउज़र में पॉपअप सेटिंग्स की जांच करें",
    "dashboard.your_todo_list": "आपकी कार्य सूची",
    "notifications.award_unit_has_been_returned": "अवार्ड यूनिट को संशोधित किया गया है",
    "moduleTitle.participant_activities": "प्रतिभागी की गतिविधियों",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "अवार्ड लीडर्स",
    "aj.preparation": "तैयारी",
    "button.change_state": "स्थिति बदलें",
    "label.current_password": "वर्तमान पासवर्ड",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "संपर्क सेटिंग्स",
    "button.remove_photo": "फोटो निकालें",
    "notifications.activity_has_been_setup": "गतिविधि सेट की गई है",
    "errors.must_be_more_than": "{limit} से अधिक होना चाहिए",
    "table.goal": "लक्ष्य",
    "notifications.coordinator_has_been_set": "समन्वयक सेट कर दिया गया है",
    "label.cc": "कॉपी",
    "label.duration": "अवधि",
    "table.actions": "क्रिया",
    "participant.send_email_invitation_again": "ईमेल आमंत्रण फिर से भेजें?",
    "moduleTitle.would_you_like_to_remove_participant": "क्या आप प्रतिभागी #{value} को हटाना चाहते हैं",
    "parentalConsent.i_authorise_employees": "4. मैं अवार्ड यूनिट के कर्मचारियों, अधिकारियों या एजेंटों और जो अन्य व्यक्ति इस पुरस्कार के आयोजन में शामिल हैं या उनकी सहायता करते हैं, को अधिकृत करता हूं कि किसी भी गतिविधि या कार्य से संबंधित भाग लेने या उससे यात्रा करने के दौरान, किसी भी दुर्घटना, चोट, बीमारी या नुकसान में होने वाली स्थिति में आवश्यक चिकित्सा सहायता या उपचार \nप्राप्त करें जो की किसी भी चिकित्सक, नर्सों या अस्पताल तक सीमित नहीं है।",
    "button.reload_page": "पृष्ठ पुनः लोड करें",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "ईमेल",
    "label.new_goal": "नया लक्ष्य",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "अमान्य ईमेल पता",
    "pageTitle.new_contact": "नया संपर्क",
    "sidebar.gops": "",
    "button.manage_participants": "प्रतिभागियों को प्रबंधित करें",
    "errors.invalid_phone_format": "अवैध फोन नंबर",
    "notifications.login_details_have_been_changed": "लॉगिन विवरण बदल दिया गया है",
    "moduleTitle.participant_logs": "प्रतिभागी के लॉग",
    "label.save": "सहेजें",
    "label.frequently_asked_questions": "अक्सर पूछे जाने वाले प्रश्न",
    "label.city": "शहर",
    "notifications.configuration_value_has_been_reset": "कॉन्फ़िगरेशन मान को रीसेट कर दिया गया है",
    "states.office_sign_off": "अवार्ड ऑफिस साइन-ऑफ",
    "button.save": "सहेजें",
    "button.import_data_from_selected_file": "चयनित फ़ाइल से डेटा आयात करें",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. मैं समझता हूं कि प्रतिभागी अवार्ड के किसी भी विशेष खंड को शुरू नहीं कर सकते जब तक कि मैं खुद से संतुष्ट न हो कि प्रतिभागी द्वारा नामांकित कोई स्वयंसेवक, जो अवार्ड यूनिट का कर्मचारी नहीं है, अनुभाग का हिदायत / निगरानी / आकलन के लिए उपयुक्त और / या  अनुभवी न हो; और जब तक किसी भी संबंधित स्वयंसेवकों ने अवार्ड यूनिट के अवार्ड से सम्बंधित दस्तावेजों को पूरा कर वापस कर दिए हैं।",
    "pageTitle.apiKeys": "",
    "label.international_region": "अंतर्राष्ट्रीय क्षेत्र",
    "tabs.levels": "स्तर",
    "tabs.additional_files": "अतिरिक्त फ़ाइलें",
    "label.continuation_level": "निरंतरता का स्तर",
    "table.adventurous_journey_detail": "साहसिक यात्रा का विवरण",
    "button.set": "सेट",
    "label.i_certify_that_as_the_assessor": "मैं इस गतिविधि के {role} के रूप में प्रमाणित करता हूँ कि प्रतिभागी आवश्यकताओं को पूरा करता है",
    "table.coordinator": "समन्वयक",
    "participant.send_confirmation_email_again": "पुष्टि ईमेल फिर से भेजें?",
    "table.report": "रिपोर्ट",
    "label.update_translations_results": "",
    "table.observation_note": "निरीक्षण नोट",
    "label.view_more": "और देखो",
    "notifications.payment_link_has_been_reset": "भुगतान लिंक रीसेट कर दिया गया है",
    "table.type": "प्रकार",
    "moduleTitle.updateConfigurationKey": "कॉन्फ़िगरेशन कुंजी अपडेट करें",
    "sidebar.independent_award_centers": "स्वतंत्र अवार्ड केंद्र",
    "table.activity_type": "गतिविधि का प्रकार",
    "label.awardMode.online": "ऑनलाइन",
    "table.data_state": "",
    "button.generate_report": "रिपोर्ट बनाएं",
    "moduleTitle.assessed_by_award_leader": "अवार्ड लीडर द्वारा मूल्यांकन",
    "table.child_protection_number": "बाल संरक्षण नंबर",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "अवार्ड की स्तिथि",
    "moduleTitle.overview": "अवलोकन",
    "table.aj_detail": "साहसिक यात्रा का विवरण",
    "pageTitle.tasks_activity_approvals": "गतिविधि अनुमोदन",
    "label.section": "अनुभाग",
    "route.history": "इतिहास",
    "route.event_participants": "घटना प्रतिभागी",
    "participant.account_detail": "अकाउंट सेटिंग",
    "route.dashboard": "डैशबोर्ड",
    "table.payments": "भुगतान",
    "pageTitle.profile": "प्रोफाइल",
    "organisation.remove_organisation": "संगठन निकालें",
    "pageTitle.my_organization": "मेरा संगठन",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "मूल्यांकनकर्ता को अद्यतन किया गया है",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "ड्यूक",
    "table.qualifying": "योग्यता",
    "button.upload": "अपलोड",
    "button.resend": "दुबारा भेजें",
    "label.filename": "फ़ाइल का नाम",
    "label.change_parental_consent": "",
    "button.cancel": "रद्द करें",
    "label.aply_to_all_langs": "",
    "route.customization": "अनुकूलन",
    "errors.minimal_duration_is": "न्यूनतम अवधि 30 मिनट है",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "प्रतिभागी की स्थिति",
    "award.bronze_level_short": "कांस्य",
    "label.phone_type": "फोन प्रकार",
    "global.night": "रात",
    "button.adventurous_journey_settings": "साहसिक यात्रा सेटिंग",
    "participant.leader_must_be_selected": "लीडर चुना जाना चाहिए",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "उपयोगकर्ता ने तैयारी और प्रशिक्षण जोड़ा",
    "table.approve": "अनुमोदन",
    "label.role_in_organisation": "संगठन में भूमिका",
    "states.finished": "समाप्त हो गया",
    "label.created": "बनाया",
    "button.back_to_home": "होम पर वापस जाएँ",
    "label.options": "विकल्प",
    "contact.next_level_invitation": "अगला स्तर आमंत्रण",
    "moduleTitle.activity_detail": "गतिविधि का विवरण",
    "route.section_signoff": "अनुभाग साइन-ऑफ",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "संपर्क सेटिंग्स",
    "label.transation_id": "लेनदेन आईडी",
    "notifications.activity_has_been_updated": "गतिविधि को अपडेट कर दिया गया है",
    "sidebar.awards": "अवार्ड्स",
    "parentalConsent.images_consent": "माता-पिता / अभिभावक के रूप में, मैं प्रचार उद्देश्यों के लिए फाउंडेशन द्वारा उपयोग की जाने वाली किसी भी छवियों के लिए सहमति देता हूं",
    "participant.would_you_like_to_delete": "क्या आप इस खाते को हटाना चाहते हैं?",
    "roles.user": "उपयोगकर्ता",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "कोई परिणाम नहीं",
    "moduleTitle.address_line_2": "पता दूसरी पंक्ति",
    "states.awaiting_office_sign_off": "अवार्ड ऑफिस साइन-ऑफ",
    "moduleTitle.export": "एक्सपोर्ट",
    "moduleTitle.address_line_1": "पता प्रथम पंक्ति",
    "notifications.participant_has_been_assigned": "प्रतिभागी सौंपा गया है",
    "roles.viewer": "दर्शक",
    "label.participants_total": "प्रतिभागी कुल",
    "errors.auth_code_is_no_longer_valid": "प्राधिकरण कोड अब मान्य नहीं है - इसका इस्तेमाल हो चुका है या इसकी समय सीमा समाप्त हो गई है",
    "label.file_is_not_available": "फ़ाइल उपलब्ध नहीं है",
    "button.select_template": "टेम्पलेट चुनें",
    "label.payment": "भुगतान",
    "award.silver_level_short": "रजत",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "आपकी व्यक्तिगत जानकारी",
    "aj.minimum_date_recommendation": "अभ्यास AJ और {name} के लिए न्यूनतम तिथि सिफारिश है",
    "label.date_of_payment": "भुगतान की तिथि",
    "button.view": "देखें",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "प्रतिभागियों को सेट करें",
    "roles.assessor": "आंकलन करनेवाला",
    "moduleTitle.coordinator_settings": "समन्वयक सेटिंग्स",
    "label.parent_relationship": "माता-पिता के रिश्ते",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "ईमेल भेजा जा चुका है",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "उप-संचालन प्राधिकरण",
    "route.award": "अवार्ड",
    "label.no_roles": "कोई भूमिका नहीं",
    "table.files": "फ़ाइलें",
    "aj.minimum_date_requirements": "योग्यता AJ और {name} के लिए न्यूनतम तिथि सिफारिश है",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "प्रतिभागी ऑफ़लाइन है",
    "moduleTitle.other_coordinators": "अन्य समन्वयक",
    "button.updateSelectedLanguage": "button.updateSelectedLanguage",
    "tasks.approve_award_registration": "अवार्ड पंजीकरण को मंजूरी दें",
    "participant.invite_participant_to_next_level": "प्रतिभागी को अगले स्तर पर आमंत्रित करें?",
    "label.twitter": "ट्विटर",
    "pageTitle.awards": "अवार्ड्स",
    "warning.award_marked_as_paid": "",
    "table.edit": "समीक्षा",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "अंतर्राष्ट्रीय अवार्ड",
    "moduleTitle.after_assigning_a_role_to_yourself": "अपने लिए भूमिका सौंपने या बदलने के बाद आपको फिर से प्रवेश करना होगा।",
    "label.transaction_id": "लेनदेन आईडी",
    "table.suboperating_authority": "उप-संचालन प्राधिकरण",
    "label.participant_survey": "एक पुरस्कार प्रतिभागी के रूप में मैं फाउंडेशन के सर्वेक्षण में भाग लेने में खुश हूं",
    "label.created_by": "द्वारा बनाया",
    "button.send_confirmation_email_again_question": "पुष्टि ईमेल फिर से भेजें?",
    "label.email_help_award_leader_email": "",
    "label.name": "नाम",
    "tabs.gold_level": "स्वर्ण स्तर",
    "pageTitle.award_documents": "अवार्ड दस्तावेज",
    "label.online_payments": "ऑनलाइन भुगतान",
    "label.child_protection_number": "बाल संरक्षण नंबर",
    "participant.send_password_recovery_email": "पासवर्ड पुनर्प्राप्ति ईमेल भेजें?",
    "notifications.new_log_has_been_added": "नया लॉग जोड़ दिया गया है",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "संगठन का नाम",
    "pageTitle.my_organization_templates": "मेरा संगठन - टेम्पलेट",
    "pageTitle.award_leaders": "अवार्ड लीडर्स",
    "label.status": "स्थिति",
    "label.street": "सड़क",
    "roles.if_staff_superuser": "आई ऍफ़ स्टाफ सुपर यूजर",
    "table.licence_holder": "लाइसेंस धारक",
    "label.created_at": "पर बनाया",
    "table.section": "अनुभाग",
    "table.system_rights": "सिस्टम राइट्स",
    "label.iac_type": "IAC का प्रकार",
    "label.other": "अन्य",
    "moduleTitle.login": "लॉग इन करें",
    "label.no_data_to_show": "दिखाने के लिए कोई डेटा नहीं है",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "यदि प्रतिभागियों को साहसिक यात्रा के लिए सौंप दिया गया है तो award स्तर को संशोधित नहीं किया जा सकता है",
    "tabs.waiting_payments": "भुगतान - प्रतीक्षारत",
    "global.supervisor": "पर्यावेक्षक",
    "notifications.new_role_has_been_added": "नई भूमिका जोड़ दी गई है",
    "award.silver_level": "रजत स्तर",
    "heading.change_awards_mode": "अवार्ड का मोड बदलें",
    "button.save_changes": "परिवर्तनों को सुरक्षित करें",
    "organisation.would_you_like_to_move_award_unit": "आप इस संगठन को कहां से निकालना चाहते हैं?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "मेरा क्षेत्र कार्यालय - विवरण",
    "table.started_at": "इस समय पर शुरू किया",
    "parentalConsent.i_consent_to_the_award_unit": "2. मैं अवार्ड यूनिट और स्वयंसेवकों * सहित अन्य किसी भी व्यक्ति, जो अवार्ड के आयोजन में शामिल हैं या सहायता करते हैं, और किराये पे लिए गए परिवहन ड्राइवरों  जो प्रतिभागियों को पुरस्कार से संबंधित गतिविधियों या कार्यों में भाग लेने के उद्देश्य से ले जाते हैं, ज़रूरत के अनुसार सहमती देता हूँ। मैं समझता हूं कि अवार्ड यूनिट मुझे पहले बताएगी कि यह यात्रा कब और कहाँ होगी।",
    "logs.minutes": "मिनट्स",
    "label.total_participants": "कुल प्रतिभागी",
    "moduleTitle.contact_info": "संपर्क जानकारी",
    "table.payment_link": "भुगतान लिंक",
    "errors.please_contact_your_local_award_staff": "कृपया अपने स्थानीय अवार्ड स्टाफ से संपर्क करें।"
}